// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kingdra: PokeData = {
  "id": 230,
  "name": "kingdra",
  "height": 18,
  "weight": 1520,
  "base_experience": 243,
  "types": [
    PokeType.WATER,
    PokeType.DRAGON
  ],
  "api_moves": [
    "leer",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "agility",
    "smokescreen",
    "focus-energy",
    "bubble",
    "dragon-breath",
    "twister",
    "rain-dance",
    "whirlpool",
    "yawn",
    "dragon-dance",
    "water-pulse",
    "brine",
    "dragon-pulse",
    "laser-focus",
    "wave-crash"
  ],
  "moves": [
    "leer",
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "dragon-breath",
    "rain-dance",
    "whirlpool",
    "dragon-dance",
    "brine",
    "dragon-pulse",
    "outrage",
    "great-roar",
    "aqua-jet"
  ],
  "evolution_chain": {
    "id": 54,
    "item": null,
    "species": [
      {
        "name": "horsea",
        "order": 132,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "seadra",
        "order": 133,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 116,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "kingdra",
        "order": 134,
        "types": [
          PokeType.WATER,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 117,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 128,
    "speed": 128,
    "ability_power": 143
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
